import { useQueryClient } from '@tanstack/react-query';
import keys from './keys';
import userKeys from '../user/keys';
import useApiMutation from '../useApiMutation';

const useSetShow = () => {
  const queryClient = useQueryClient();

  const mutation = useApiMutation({
    getRequestUrl: ({ showId } = {}) => `/shows/${showId}`,
    method: 'PATCH',
    onSuccess: (newShowData) => {
      queryClient.invalidateQueries(userKeys.me);
      queryClient.invalidateQueries(keys(newShowData.showId).show);
      queryClient.setQueryData(keys(newShowData.showId).show, newShowData);
    },
  });

  return {
    setShow: mutation.mutate,
    isSetShowLoading: mutation.isLoading,
    isSetShowError: mutation.isError,
    isSetShowSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useSetShow;
